import {ACCEPTED, DECLINED, WAITING_FOR_DECISION} from "./employeeStatus";
import {COMPANY_DB_PATH, EMPLOYEE_DB_PATH} from "../constants/DB_PATHS";
import {COMPANY_PIC_PATH, PROFILE_PIC_PATH} from "../constants/STORAGE_PATHS";

export async function signUpToCompany(firestore,
                                      userId,
                                      companyId,
                                      companyName,
                                      firebase = null,
) {
    await firestore.collection('users').doc(userId).update({
        companyId: companyId,
        employeeStatus: WAITING_FOR_DECISION,
    })
    await firestore.collection(EMPLOYEE_DB_PATH).doc(userId).update({
        employeeCompanyName: companyName,
        employeeCompanyNameId: companyId,
        employeeStatus: WAITING_FOR_DECISION,

    })
}

export async function declineUserFromCompany(firestore,
                                             userId) {
    await firestore.collection('users').doc(userId).update({
        companyId: '',
        employeeStatus: DECLINED,
    })
}

export async function acceptUserToCompany(firestore,
                                          userId,
                                          companyId,
) {
    firestore.collection('users').doc(userId).update({
        employeeStatus: ACCEPTED,
    })
    firestore.collection(COMPANY_DB_PATH)
        .doc(companyId).update({
        employees:
            firestore.FieldValue.arrayUnion(userId),
        exEmployees: firestore
            .FieldValue.arrayRemove(userId),
    })
    firestore.collection(COMPANY_DB_PATH)
        .doc(companyId).collection('employees')
        .doc(userId).set({
        employeeId: userId,
        joinDate: new Date(),
        status: ACCEPTED
    })
    firestore.collection(EMPLOYEE_DB_PATH).doc(userId)
        .update({
            joinDate: new Date(),
            employeeStatus: ACCEPTED,
        })
}

export async function exitUserFromCompany(firestore, userId, companyId, firebase = null,) {
    await firestore.collection('users').doc(userId).update({
        companyId: '',
        employeeStatus: DECLINED,
    })
    await firestore.collection(COMPANY_DB_PATH)
        .doc(companyId).update({
            employees: firestore
                .FieldValue.arrayRemove(userId),
            exEmployees: firestore
                .FieldValue.arrayUnion(userId),
        })
    await firestore
        .collection(COMPANY_DB_PATH)
        .doc(companyId)
        .collection('employees')
        .doc(userId).update({
            exitDate: new Date(),
            status: DECLINED
        })
    await firestore.collection(EMPLOYEE_DB_PATH)
        .doc(userId).update({
            exitDate: new Date(),
            employeeStatus: DECLINED,
            employeeCompanyNameId: '',
            employeeCompanyName: '',
        })

}


export async function setCompanyProfilePicture(firebase, file, companyId) {
    await firebase.uploadFile(
        COMPANY_PIC_PATH,
        file,
        COMPANY_DB_PATH,
        {
            //name: (file) => `${this.props.auth.uid}-${Date.now()}`,
            name: () => `${companyId}`,
            metadataFactory: (uploadRes, firebase, metadata, downloadURL) => {
                console.log(downloadURL)
                return {companyImgUrl: downloadURL}
            },
            documentId: companyId
        }
    )
}

export async function setProfilePicture(firebase, file, profileId) {
    await firebase.uploadFile(
        PROFILE_PIC_PATH,
        file,
        'users',
        {
            //name: (file) => `${this.props.auth.uid}-${Date.now()}`,
            name: () => `${profileId}`,
            metadataFactory: (uploadRes, firebase, metadata, downloadURL) => {
                console.log(downloadURL)
                return {profileImgUrl: downloadURL}
            },
            documentId: profileId
        }
    )
}

export async function setProfileData(firebase, firestore, profileId,
                                     firstN,
                                     lastN,
) {
    await firebase.updateAuth({
        displayName: `${firstN} ${lastN}`
    })
    await firestore.collection('users').doc(profileId).update({
        firstN: firstN,
        lastN: lastN,
    })


}